/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const instanceNodeInputClientIdMax = 36;

export const instanceNodeInputClientIdRegExp = new RegExp('^[a-z0-9._:-]+$');

export const InstanceNodeInput = zod.object({
  clientId: zod
    .string()
    .min(1)
    .max(instanceNodeInputClientIdMax)
    .regex(instanceNodeInputClientIdRegExp)
    .describe(
      'Caller-supplied temporary node reference, unique within the request. Used to wire edges and to look up the created UUID in the response. Use lowercase letters, numbers, dots, underscores, colons, or hyphens.',
    ),
  contentTypeUuid: zod.uuid().describe('UUID of the content TYPE this instance is an instance of.'),
  occurredAt: zod.string().optional().describe('ISO date-time the instance datum occurred at.'),
  subjectUuid: zod.uuid().optional().describe('UUID v4 identifier'),
  value: zod
    .object({
      booleanValue: zod.boolean().nullish(),
      dateValue: zod.string().nullish(),
      datetimeValue: zod.string().nullish(),
      jsonValue: zod.unknown().optional(),
      numericValue: zod.number().nullish(),
      stringValue: zod.string().nullish(),
    })
    .optional(),
});

export type InstanceNodeInput = zod.input<typeof InstanceNodeInput>;
export type InstanceNodeInputOutput = zod.output<typeof InstanceNodeInput>;
